import React from 'react';

const StructuredData = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Shanghai RunTheRays International Trade Co., Ltd.",
    "alternateName": "RunTheRays",
    "url": "https://www.runtheraysintl.com",
    "logo": "https://www.runtheraysintl.com/logo.png",
    "description": "Professional international trade service provider specializing in sourcing, quality control, warehousing, and supply-chain management in China.",
    "foundingDate": "2019",
    "email": "abbewray@runtheraysintl.com",
    "telephone": ["+86-198-2182-9731", "+86-131-6605-7223"],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Shanghai",
      "addressCountry": "CN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "31.230416",
      "longitude": "121.473701"
    },
    "areaServed": [
      {
        "@type": "Country",
        "name": "Global"
      }
    ],
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "31.230416",
        "longitude": "121.473701"
      },
      "geoRadius": "Global"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+86-198-2182-9731",
        "contactType": "Customer Service",
        "email": "abbewray@runtheraysintl.com",
        "availableLanguage": ["English", "Chinese"]
      }
    ],
    "sameAs": [
      "https://www.linkedin.com/company/shanghai-runtherays",
      "https://wa.me/8613166057223"
    ]
  };

  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "International Trade Services",
    "provider": {
      "@type": "Organization",
      "name": "Shanghai RunTheRays International Trade Co., Ltd."
    },
    "areaServed": "Worldwide",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Trade Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Sourcing Solutions",
            "description": "Connect with reliable, verified manufacturers and suppliers across China"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Warehousing Services",
            "description": "State-of-the-art facilities with advanced inventory management systems (SAP)"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Quality Control & Inspection",
            "description": "Rigorous inspections and compliance checks for international standards"
          }
        }
      ]
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.runtheraysintl.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://www.runtheraysintl.com#services"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Contact",
        "item": "https://www.runtheraysintl.com#quote"
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Shanghai RunTheRays International Trade Co., Ltd.",
    "image": "https://images.unsplash.com/photo-1670121180583-39ab653a071c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxpbnRlcm5hdGlvbmFsJTIwdHJhZGV8ZW58MHx8fHwxNzY4Mjg2ODAwfDA&ixlib=rb-4.1.0&q=85",
    "@id": "https://www.runtheraysintl.com",
    "url": "https://www.runtheraysintl.com",
    "telephone": "+86-198-2182-9731",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Shanghai",
      "addressCountry": "CN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 31.230416,
      "longitude": 121.473701
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "18:00"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "100"
    }
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(servicesSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }} />
    </>
  );
};

export default StructuredData;
